import { defineProperty as _defineProperty } from './_virtual/_rollupPluginBabelHelpers.js';
var LEVEL_DEBUG = 'debug';
var LEVEL_INFO = 'info';
var LEVEL_WARN = 'warn';
var LEVEL_ERROR = 'error';
var LEVEL_CRITICAL = 'critical';
var constants = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, LEVEL_DEBUG, 1), LEVEL_INFO, 2), LEVEL_WARN, 3), LEVEL_ERROR, 4), LEVEL_CRITICAL, 5);
export { LEVEL_CRITICAL, LEVEL_DEBUG, LEVEL_ERROR, LEVEL_INFO, LEVEL_WARN, constants as default };